<template>
  <insurance-host />
</template>
<script>
import InsuranceHost from '@/components/insurance/InsuranceHost.vue'
export default {
  name: 'InsuranceView',
  components: {
    InsuranceHost
  }
}
</script>
<style lang="scss" scoped></style>
